/* Tema Gomitas Garcinias — theme.js */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Galería con deslizar, flechas, puntos y miniaturas ---------- */
  function initGallery(g) {
    if (g.__gg) return; g.__gg = true;
    var slides = g.querySelectorAll('.gg-gal-slide');
    var dotsBox = g.querySelector('[data-gg-dots]'), thumbsBox = g.querySelector('[data-gg-thumbs]');
    var hint = g.querySelector('[data-gg-hint]'), main = g.querySelector('.gg-gal-main');
    var prev = g.querySelector('[data-gg-prev]'), next = g.querySelector('[data-gg-next]');
    var cur = 0, touched = false, timer = null;
    if (slides.length < 2) { [prev, next, hint].forEach(function (e) { if (e) e.style.display = 'none'; }); return; }
    var dots = [], thumbs = [];
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('i'); dotsBox.appendChild(d); dots.push(d);
      var img = slides[i].querySelector('img');
      var t = document.createElement('button'); t.type = 'button'; t.className = 'gg-thumb'; t.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      if (img) { var ti = document.createElement('img'); ti.src = img.currentSrc || img.src; ti.alt = ''; ti.loading = 'lazy'; t.appendChild(ti); }
      (function (k) { t.addEventListener('click', function () { stop(); show(k); }); })(i);
      thumbsBox.appendChild(t); thumbs.push(t);
    }
    function show(n) {
      cur = (n + slides.length) % slides.length;
      for (var j = 0; j < slides.length; j++) {
        slides[j].classList.toggle('is-on', j === cur);
        dots[j].classList.toggle('is-on', j === cur);
        thumbs[j].classList.toggle('is-on', j === cur);
      }
    }
    function stop() { if (!touched) { touched = true; if (timer) clearInterval(timer); if (hint) hint.classList.add('is-hidden'); } }
    show(0);
    prev.addEventListener('click', function () { stop(); show(cur - 1); });
    next.addEventListener('click', function () { stop(); show(cur + 1); });
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) { stop(); show(dx < 0 ? cur + 1 : cur - 1); }
      x0 = null;
    }, { passive: true });
    if (g.getAttribute('data-autoplay') === 'true' && !reduce) {
      timer = setInterval(function () { if (!touched) show(cur + 1); }, 3500);
    }
  }

  /* ---------- Línea de tiempo que se dibuja ---------- */
  function initTimeline(tl) {
    if (tl.__gg) return; tl.__gg = true;
    if (!('IntersectionObserver' in window)) { tl.classList.add('is-in'); return; }
    new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { tl.classList.add('is-in'); o.disconnect(); } }, { threshold: 0.2 }).observe(tl);
  }

  /* ---------- Contador hasta la medianoche ---------- */
  function initCountdown(cd) {
    if (cd.__gg) return; cd.__gg = true;
    var h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]'), s = cd.querySelector('[data-s]');
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var n = new Date(), f = new Date(n); f.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((f - n) / 1000));
      h.textContent = p(Math.floor(d / 3600)); m.textContent = p(Math.floor(d % 3600 / 60)); s.textContent = p(d % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Barra fija de compra ---------- */
  function initSticky() {
    var st = document.querySelector('[data-gg-sticky]'), hero = document.querySelector('[data-gg-hero]');
    if (!st || !hero || st.__gg) return; st.__gg = true;
    if (!('IntersectionObserver' in window)) { st.classList.add('is-on'); return; }
    new IntersectionObserver(function (e) {
      st.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(hero);
  }

  /* ---------- Compra sin EasySell: agrega al carrito y va al pago ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gg-buy]');
    if (!b) return;
    var f = document.querySelector('[data-gg-form]');
    if (f) { e.preventDefault(); f.submit(); }
  });

  /* ---------- Menú móvil ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gg-menu-toggle]');
    if (!t) return;
    var m = document.querySelector('[data-gg-menu]'); if (!m) return;
    var open = m.classList.toggle('is-open'); t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });


  /* ---------- Tarjetas que se voltean ---------- */
  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('[data-gg-flip]');
    if (!f) return;
    var on = f.classList.toggle('is-flipped'); f.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  /* ---------- Haz la cuenta: pestañas de rivales ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gg-rv-tab]');
    if (!t) return;
    var box = t.closest('[data-gg-rounds]'), i = t.getAttribute('data-gg-rv-tab');
    box.querySelectorAll('[data-gg-rv-tab]').forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    box.querySelectorAll('[data-gg-rv]').forEach(function (p) {
      var on = p.getAttribute('data-gg-rv') === i; p.classList.remove('is-play'); p.classList.toggle('is-on', on);
      if (on) { void p.offsetWidth; p.classList.add('is-play'); }
    });
  });
  function initRounds(box) {
    if (box.__gg) return; box.__gg = true;
    var play = function () { var p = box.querySelector('.gg-rv.is-on'); if (p) p.classList.add('is-play'); };
    if (!('IntersectionObserver' in window)) return play();
    new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { play(); o.disconnect(); } }, { threshold: 0.25 }).observe(box);
  }

  /* ---------- Preguntas tipo chat ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-gg-q]');
    if (!q || q.disabled) return;
    var chat = q.closest('[data-gg-chat]'), log = chat.querySelector('[data-gg-chat-log]');
    var tpl = q.querySelector('template'), answer = tpl ? tpl.innerHTML : '';
    var question = q.childNodes[0] ? q.childNodes[0].textContent : q.textContent;
    q.disabled = true; q.classList.add('is-used');
    function add(cls, html) { var d = document.createElement('div'); d.className = 'gg-msg ' + cls; d.innerHTML = html; log.appendChild(d); log.scrollTop = log.scrollHeight; return d; }
    var out = add('gg-msg--out', ''); out.textContent = question;
    var typing = add('gg-msg--in gg-msg--typing', '<i></i><i></i><i></i>');
    setTimeout(function () { typing.classList.remove('gg-msg--typing'); typing.innerHTML = answer; log.scrollTop = log.scrollHeight; }, reduce ? 0 : 900);
  });

  /* ---------- Aparición suave al hacer scroll ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.gg-sec .gg-h2, .gg-sec .gg-sub, [data-reveal], .gg-pack, .gg-rev, .gg-mech-card, .gg-flip, .gg-step');
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { if (el.__rv) return; el.__rv = true; if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('gg-rv-wait'); io.observe(el); } });
  }
  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-gg-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-gg-tl]').forEach(initTimeline);
    root.querySelectorAll('[data-gg-cd]').forEach(initCountdown);
    root.querySelectorAll('[data-gg-rounds]').forEach(initRounds);
    initReveal(root);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* Editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
